import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { MINUTES_TO_MILLIS } from "lopermut"
import { DataResponse, SupportGorgiasTicketActivityResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof SupportGorgiasTicketActivityResponseDataSchema>>

type Props = {
  enabled?: boolean
} & ({ ticketId: string } | { issueId: string })

export const gorgiasTicketActivityQuery = (props: Props) => {
  const entity = "issueId" in props ? "issues" : "tickets"
  const id = "issueId" in props ? props.issueId : props.ticketId

  return queryOptions({
    queryKey: ["support", entity, id, "gorgias", "activity"],
    queryFn: async () => {
      const response = await axios.get<Response>(`/support/${entity}/${id}/gorgias/activity`)

      return response.data.data
    },
    enabled: props.enabled,
    staleTime: 5 * MINUTES_TO_MILLIS,
  })
}
